import SimpleParallax from "simple-parallax-js";
import PvHeroImage from '../assets/hero_image.jpeg';
import Button from "react-bootstrap/esm/Button";
import BookButton from "./BookButton";
import './HeroImage.css';

const HeroImage = ({ onOpenModal }) => {
  return (
    <div className="hero-image">
      <SimpleParallax>
        <img src={PvHeroImage} alt="Solstice Studios AZ tinting windows in a client's home" className="parallax-image" />
      </SimpleParallax>
      <div className="overlay">
        <div className="overlay-text"> We'd love to see you!</div>
        <div className="button-container">
        {/* <Button className="hero-button" onClick={onOpenModal}>Paint & Sip</Button> */}
        <BookButton className="hero-button" />
        {/* <Button className="hero-button" onClick={onOpenModal}>Kid's Classes</Button> */}
        <Button className="hero-button" onClick={onOpenModal}>Local Events</Button>
        </div>
      </div>
    </div>
  );
}

export default HeroImage;